import axios from '@/utils/http';

export default (
  page,
  per_page,
  type,
  asset_id,
  legal_currency_id,
  pay_method_id,
  order,
  is_me,
  user_id,
) => {
  let url = `/home-advertisements?page=${page}&per_page=${per_page}`;
  if (type) {
    url += `&type=${type}`;
  }
  if (asset_id) {
    url += `&asset_id=${asset_id}`;
  }
  if (legal_currency_id) {
    url += `&legal_currency_id=${legal_currency_id}`;
  }
  if (pay_method_id) {
    url += `&pay_method_id=${pay_method_id}`;
  }
  if (
    'recommend,price_asc,price_desc,order_count,turnover,evaluation,created_at,updated_at'.indexOf(
      order,
    ) >= 0
  ) {
    url += `&order=${order}`;
  }
  if (is_me) {
    url += `&is_me=${is_me}`;
  }
  if (user_id) {
    url += `&user_id=${user_id}`;
  }
  return axios
    .get(url)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
